// libs
import React, { memo } from 'react';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

// helpers
import { sortByKey } from 'shared/components/AdPlatformWidgets/helpers';

// types
import { ILandingPageWidget, IWidgetItems } from 'shared/components/AdPlatformWidgets/types';

// components
import WidgetTitle from 'shared/components/AdPlatformWidgets/components/WidgetTitle';

// constants
import { WIDGET_THEMES } from 'shared/components/AdPlatformWidgets/constants';

// styles
import { Container, WidgetsContainer } from './styles';

// helper
import { getComponent, getGridParams } from './helpers';

// def
interface IGridProps {
  widget: ILandingPageWidget;
}

function Grid({ widget }: IGridProps) {
  const widgetItems: IWidgetItems[] = sortByKey(
    get(widget, 'widget_data.children', []),
    'positionInParent'
  );

  let columnCount = 1;
  let className = '';

  const {
    title,
    titleAlign,
    theme,
    inventoryName,
    numOfColumns,
    contentAlign,
    backgroundColor,
    textColor,
  } = getGridParams(widget);
  columnCount = numOfColumns;

  switch (theme) {
    case WIDGET_THEMES.NEW_ABOARD_WIDGET:
      className = 'textOverImage';
      columnCount = 3;
      break;
    case WIDGET_THEMES.CONTENT_WIDGET:
      columnCount = 2;
      break;
  }

  const Child = widgetItems.map((widgetItem, idx: number) => {
    let action_type = get(widgetItem, 'parameters.web_action_type');
    action_type = isEmpty(action_type) ? 'none' : action_type;
    const Component = getComponent(widgetItem.wtype, action_type);

    if (isEmpty(Component)) return null;

    return (
      <Component
        key={idx}
        childCount={idx + 1}
        numOfColumns={columnCount}
        widgetItem={widgetItem}
        inventoryName={inventoryName}
        className={className}
        contentAlign={contentAlign}
        textColor={textColor}
      />
    );
  });

  const marginTop = get(widget, 'widget_data.parameters.margin_top');

  return (
    <WidgetsContainer marginTop={marginTop} backgroundColor={backgroundColor} textColor={textColor}>
      {title && <WidgetTitle title={title} alignment={titleAlign} />}
      <Container>{Child}</Container>
    </WidgetsContainer>
  );
}

export default memo(Grid);
